
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.107 11.852a.48.48 0 00.148-.352.48.48 0 00-.148-.352.48.48 0 00-.352-.148.48.48 0 00-.351.148.48.48 0 00-.149.352c0 .135.05.253.149.352a.48.48 0 00.351.148.48.48 0 00.352-.148zm2 0a.48.48 0 00.148-.352.48.48 0 00-.148-.352.48.48 0 00-.352-.148.48.48 0 00-.351.148.48.48 0 00-.149.352c0 .135.05.253.149.352a.48.48 0 00.351.148.48.48 0 00.352-.148zm1.148-2.102v2.5a.723.723 0 01-.218.531.723.723 0 01-.532.219h-11.5a.723.723 0 01-.53-.219.724.724 0 01-.22-.531v-2.5c0-.208.073-.385.22-.531A.723.723 0 011.004 9h3.336c.11.292.292.531.547.719.26.187.55.281.867.281h2c.318 0 .605-.094.86-.281.26-.188.445-.427.554-.719h3.336c.209 0 .386.073.532.219a.723.723 0 01.218.531zm-2.539-5.063c-.088.209-.242.313-.46.313h-2v3.5a.48.48 0 01-.15.352.48.48 0 01-.35.148h-2a.48.48 0 01-.352-.148.48.48 0 01-.149-.352V5h-2c-.218 0-.372-.104-.46-.313-.09-.203-.053-.382.109-.539l3.5-3.5A.464.464 0 016.755.5c.141 0 .258.05.352.148l3.5 3.5c.161.157.198.336.11.54z","fill":"#00A8E9"}})])
          )
        }
      }
    